export default __webpack_public_path__ + "static/smile-00fc62af14549358dd9f3ebbcb66ba59.png";